// ---------------------- Props

interface BookingCalendarItemProps {
  title: string;
  value: string;
}

// ---------------------- Component

const BookingCalendarItem = ({ title, value }: BookingCalendarItemProps) => {
  // --------- JSX

  return (
    <>
      <div className="font-base flex flex-row items-start justify-start gap-3 text-xs text-gray-800 dark:text-gray-200 sm:text-sm">
        <p className="min-w-8 font-bold sm:min-w-10">{title}</p>

        <p className="flex-grow">{value}</p>
      </div>
    </>
  );
};

export default BookingCalendarItem;
